/**
 * These are custom events that keep Angular and React state in sync.
 *
 * This file is duplicated in `packages-legacy`. Any changes should be reflected in both places.
 *
 * @see {@link ../../packages-legacy/public/js/pages/lib/eventEnums.js}
 */
export const ReactToAngularEvent = {
  DASH_SIDEBAR_LOADED: 'readme:dashSidebarLoaded',
  OPEN_UPLOAD_API_MODAL: 'readme:openUploadAPIModal',
  QUICKSTART_UPDATE_STEPS: 'readme:quickstartUpdateSteps',
  METRICS_ONBOARDING_COMPLETE: 'readme:metricsOnboardingComplete',
  UPDATE_NG_PROJECT_FLAGS: 'readme:updateProjectFlags',
} as const;
